// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1143":"7f55f5bf","9411":"a0d4af8d"}[chunkId] + ".chunk.css";
};